import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../environments/environment';
import { BetSlipCombiBonusTier } from './betslip/betslip-ticket.models';
import { SessionService } from './session.service';

export interface BettingSettings {
  readonly cashoutEnabled?: boolean;
  readonly taxRate: number;
  readonly maxProfit: number;
  readonly maxOdds: number;
  readonly minStake: number;
  readonly maxStake: number;
  readonly combiBonus: readonly BetSlipCombiBonusTier[];
}

interface BettingSettingsResponse {
  readonly EnableCashOut?: boolean;
  readonly TaxRate: number;
  readonly MaxProfit: number;
  readonly MaxOdd: number;
  readonly MinStake: number;
  readonly MaxStake: number;
  readonly CombiBonusEnabled: boolean;
  readonly CombiBonus: readonly {
    readonly Bonus: number;
    readonly Combi: number;
  }[];
}

@Injectable({ providedIn: 'root' })
export class BettingSettingsService {
  private readonly http = inject(HttpClient);
  private readonly session = inject(SessionService);

  loadSettings(): void {
    this.http.get<BettingSettingsResponse>(`${environment.apiUrl}/Api/Settings`, { withCredentials: true })
      .pipe(map(response => this.mapSettings(response)))
      .subscribe(settings => this.session.setBettingSettings(settings));
  }

  private mapSettings(response: BettingSettingsResponse): BettingSettings {
    return {
      cashoutEnabled: response.EnableCashOut === true,
      taxRate: response.TaxRate,
      maxProfit: response.MaxProfit,
      maxOdds: response.MaxOdd,
      minStake: response.MinStake,
      maxStake: response.MaxStake,
      combiBonus: response.CombiBonusEnabled
        ? response.CombiBonus.map(tier => ({ combi: tier.Combi, bonus: tier.Bonus }))
        : []
    };
  }
}
